import { useMapEvents } from 'react-leaflet';

const MapEventHandler = ({ onMapChange }) => {
  const initialCenter = [39.8283, -98.5795];
  const initialZoom = 4;

  useMapEvents({
    moveend: (e) => {
      const map = e.target;
      const center = map.getCenter();
      const zoom = map.getZoom();
      
      // Check if map has moved from initial position or zoom
      const hasMovedFromInitial = 
        Math.abs(center.lat - initialCenter[0]) > 0.01 ||
        Math.abs(center.lng - initialCenter[1]) > 0.01 ||
        zoom !== initialZoom;
        
      onMapChange(hasMovedFromInitial);
    },
    zoomend: (e) => {
      const map = e.target;
      const center = map.getCenter();
      const zoom = map.getZoom();
      
      // Check if map has moved from initial position or zoom
      const hasMovedFromInitial = 
        Math.abs(center.lat - initialCenter[0]) > 0.01 ||
        Math.abs(center.lng - initialCenter[1]) > 0.01 ||
        zoom !== initialZoom;
        
      onMapChange(hasMovedFromInitial);
    }
  });

  return null;
};

export default MapEventHandler;